import { createUseStyles } from "react-jss";
import { ITheme } from "../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  store: {
    background: theme.colors.Background8,
    padding: "94px 16px 20px",
    height: "100dvh"
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    columnGap: 20,
    rowGap: 28,
    maxWidth: 420,
    margin: "0 auto",
  }
}));